import { motion } from 'framer-motion';

export function AboutStory() {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <div className="grid gap-12 md:grid-cols-2 md:items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative aspect-video overflow-hidden rounded-2xl"
          >
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
              alt="Team working together"
              className="h-full w-full object-cover"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold text-gray-900">Our Story</h2>
            <p className="mt-4 text-lg text-gray-600">
              Founded in 2024, StudySnap emerged from a simple observation: students
              spend countless hours watching educational videos but struggle to
              convert that content into effective study materials.
            </p>
            <p className="mt-4 text-lg text-gray-600">
              Our mission is clear: Converting video learning into concise,
              comprehensive textbook-style documents that enhance understanding and
              retention.
            </p>
            <div className="mt-8">
              <h3 className="bg-gradient-to-r from-indigo-500 to-purple-500 bg-clip-text text-xl font-semibold text-transparent">
                Our Vision
              </h3>
              <p className="mt-2 text-gray-600">
                To become the bridge between video content and effective learning,
                making education more accessible and efficient for students
                worldwide.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}